import { Backdrop, Fade, Modal, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'
import clsx from 'clsx'
import './CustomModal.scss'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '10px',
            boxShadow: theme.shadows[5],
            padding: '30px 40px',
            minHeight: '20vh',
            minWidth: '40%',
            // maxHeight: '90vh',
            maxWidth: '50%',
            zIndex: 9,
        },
    })
)

interface ICustomModal {
    open: boolean
    onClose: (action: string) => void
    className?: string
    modalTitle?: string
    children: React.ReactNode
    modalType?: 'general' | 'review'
}

function CustomModal(props: ICustomModal) {
    const {
        open,
        className,
        modalTitle,
        children,
        onClose,
        modalType = 'general',
    } = props
    const classes = useStyles()
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={clsx(
                classes.modal,
                className,
                'custom-modal',
                modalType === 'review' && 'review-modal'
            )}
            open={open}
            onClose={(event, reason) => {
                onClose(reason)
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className="modal-header">
                        <div className="modal-title font-weight-bold">
                            {modalTitle}
                        </div>
                        <span
                            className="action-close"
                            onClick={(e: any) => onClose(e)}
                        >
                            <CloseIcon />
                        </span>
                        <div className="divider" />
                    </div>
                    {children}
                </div>
            </Fade>
        </Modal>
    )
}

export default CustomModal
